<template>
<div class="card shadow mb-4">
  <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
    <h6 class="m-0 font-weight-bold">{{ $t('Day_of_week') }}</h6>
    <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_weekdays')"></i>
  </div>

  <div class="card-body text-center">
    <LoadingSpinner v-if="loading"></LoadingSpinner>
    <div v-show="!loading" id="canvas-weekchart"></div>
  </div>
</div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'WeekChart',
  components:{
    LoadingSpinner
  },
  data(){
    return {
      chart: null,
      sec: 0,
      clock: null
    }
  },
  mounted(){
    const self = this
    $('[data-toggle="tooltip"]').tooltip()
    this.chart = Highcharts.chart('canvas-weekchart', {
      chart: {
        type: 'column',
        backgroundColor: '#fff'
      },
      credits: { enabled: false },
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            day: '%a, %d %b'
        },
      },
      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: ''
        }
      },
      tooltip: {
        shared: true,
        xDateFormat: '%A, %d %b',
        pointFormat: '<br/><span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y:.2f}</b> kWh'
      },
      series: [{
        name: this.$i18n.t('Consumption'),
        data: [],
        color: '#f7882f'
      }, {
        name: this.$i18n.t('Production'),
        data: [],
        color: '#4187c7'
      }, {
        name: this.$i18n.t('Production_not_used'),
        data: [],
        color: '#53c8eb'
      }],
      plotOptions: {
        series: {
          events: {
            legendItemClick: function () {
              if (this.visible) _paq.push(['trackEvent', 'Geral', 'Gráfico Dia da Semana', 'Esconder (' + this.name + ')'])                        
              else _paq.push(['trackEvent', 'Geral', 'Gráfico Dia da Semana', 'Mostrar (' + this.name + ')'])
            },
            mouseOver: function () {
              self.clock = setInterval(function(){ self.sec++; }, 1000)
            },
            mouseOut: function () {
              clearInterval(self.clock);
              if(self.sec > 1) _paq.push(['trackEvent', 'Geral', 'Gráfico Dia da Semana', 'MouseOver (' + this.name + ')', self.sec])
              self.sec = 0
            }
          }
        }
      }
    })
  },
  methods:{
    set_values: function(){
      const timezone = "Atlantic/Madeira"
      /* this.chart.series[0].setData(this.data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.consumed]), false)
      this.chart.series[1].setData(this.data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.produced]), false)
      this.chart.series[2].setData(this.data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.wasted_from_produced]), false) */
      this.chart.series[0].setData(this.data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.House]), false)
      this.chart.series[1].setData(this.data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV]), false)
      this.chart.series[2].setData(this.data.map(r => [moment.tz(r.datetime, timezone).valueOf(), r.PV_Grid]), false)
      if (!this.chart.hasData()){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t('No_Data'))
      }
      this.chart.redraw()
    }
  },
  watch: {
    data: function(){
      if (this.data == null) return
      this.set_values()
    },
    current_lang: function(){
      this.chart.series[0].update({name: this.$i18n.t('Consumption')}, false);
      this.chart.series[1].update({name: this.$i18n.t('Production')}, false);
      this.chart.series[2].update({name: this.$i18n.t('Production_not_used')}, false);
      this.set_values()
    }
  },
  computed: {
    data: function(){
      return this.$store.getters.data_dailyEnergyUsed
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
